import { SUBSCRIPTION_MODULE_TYPE } from "../constants";
import subscriptionPlanService from "../services/subscriptionPlan.service";
import { paymentModalAction } from "./stripe";
import {
  GET_SUSBCRIPTION_PLAN_PRODUCTS,
  LOAD_PRODUCT_LIST,
  PRODUCT_PLAN_LOADER,
  SELECTED_SUSBCRIPTION_PLAN_PRODUCTS,
  SET_BANK_CRYPTO_DETAILS,
  SET_FAILED_MESSAGE,
  SET_PAYMENT_METHOD_SELECTION,
  SET_PLAN_COMPARE,
  SET_PLAN_COMPARE_LOADER,
  SET_PLAN_PAYLOAD,
  SET_PLAN_PREVIEW,
  SET_PLAN_PREVIEW_LOADER,
  SET_SUCCESS_MESSAGE,
  SET_TEMPORARAY_COMPANY_ID,
  TRANSACTION_SEGMENT_LIST,
} from "./types";
import { setFailedMessage } from "./message";

export const getPlanProductAction =
  (companyId, page, limit, selectedPlanProductCurrentPage, type) =>
    async (dispatch, getState) => {
      dispatch({ type: LOAD_PRODUCT_LIST, payload: true });
      return subscriptionPlanService
        .getSubscriptonPlan(companyId, page, limit, type)
        .then((resp) => {
          let defaultIndexRecord = 0;
          if (
            selectedPlanProductCurrentPage &&
            selectedPlanProductCurrentPage?.id &&
            selectedPlanProductCurrentPage?.page
          ) {
            defaultIndexRecord =
              resp.data.length > 0
                ? resp.data.findIndex(
                  (x) => x.id === selectedPlanProductCurrentPage?.id
                )
                : {};
            defaultIndexRecord = defaultIndexRecord >= 0 ? defaultIndexRecord : 0;
          }
          dispatch({
            type: GET_SUSBCRIPTION_PLAN_PRODUCTS,
            payload: resp.status ? resp.data : [],
            defaultIndex: defaultIndexRecord,
            count: resp.status ? resp?.count : 0,
          });
        });
    };

export const setTemporaryCompany = (companyId) => (dispatch) => {
  dispatch({ type: SET_TEMPORARAY_COMPANY_ID, payload: companyId })
}

export const getSingleSubscriptonPlan = (companyId, planId, selectedPlanPage, location) => async (dispatch, getState) => {
  dispatch({ type: PRODUCT_PLAN_LOADER, payload: true });

  return subscriptionPlanService
    .getSingleSubscriptonPlan(companyId, planId)
    .then((resp) => {
      if (resp.status) {
        dispatch({
          type: SELECTED_SUSBCRIPTION_PLAN_PRODUCTS,
          payload: resp?.data,
          currentPage: selectedPlanPage?.page,
          activeSegment: selectedPlanPage?.activeSegment,
          activePaidUpIndex: selectedPlanPage?.activePaidUpIndex || 0,
        });
        const type = location?.pathname?.split("/")[1] == 'book-of-business' ? SUBSCRIPTION_MODULE_TYPE.BOB : resp?.data?.planType?.value
        dispatch(paymentModalAction(false, type));
      } else {
        dispatch({
          type: SELECTED_SUSBCRIPTION_PLAN_PRODUCTS,
          payload: null,
          currentPage: selectedPlanPage?.page,
          activeSegment: selectedPlanPage?.activeSegment,
          activePaidUpIndex: selectedPlanPage?.activePaidUpIndex || 0,
        });
      }
      dispatch({ type: SET_BANK_CRYPTO_DETAILS, payload: null });
      return resp;
    });
};

export const selectedPlanProductAction =
  (item, currentPage = null, activeSegment = null, activePaidUpIndex = null) =>
    async (dispatch) => {
      dispatch({
        type: SELECTED_SUSBCRIPTION_PLAN_PRODUCTS,
        payload: item,
        currentPage: currentPage,
        activeSegment: activeSegment,
        activePaidUpIndex: activePaidUpIndex || 0,
      });
      dispatch({ type: SET_BANK_CRYPTO_DETAILS, payload: null });
      dispatch({ type: SET_PAYMENT_METHOD_SELECTION, payload: null });
    };

export const selectedTransactionSegmentRecord =
  (payload) => async (dispatch) => {
    dispatch({ type: TRANSACTION_SEGMENT_LIST, payload: payload });
  };



export const addSubscriptionAction = (payload) => (dispatch) => {
  return subscriptionPlanService.addSubscription(payload).then((resp) => {
    if (resp.status) {
      // dispatch({ type: SET_SUCCESS_MESSAGE, payload: resp.message });
      return resp;
    } else {
      dispatch({ type: SET_FAILED_MESSAGE, payload: resp.data });
    }
    return Promise.resolve();
  });
};

export const previewSubscriptionAction = (payload, data) => (dispatch) => {
  dispatch({ type: SET_PLAN_PREVIEW_LOADER, payload: true });
  return subscriptionPlanService.previewSubscription(payload).then((resp) => {
    if (resp.status) {
      dispatch({ type: SET_PLAN_PREVIEW, payload: resp.data });
      dispatch({ type: SET_PLAN_PAYLOAD, payload: data });
    } else {
      dispatch({ type: SET_PLAN_PREVIEW, payload: {} });
    }
    return Promise.resolve(resp);
  });
};

export const createBusinessPlanAction = (companyId, payload) => (dispatch) => {
  return subscriptionPlanService.createBusinessPlan(companyId, payload).then((resp) => {
    if (!resp?.status && !resp?.success) {
      dispatch(setFailedMessage(resp?.data));
    }
    return Promise.resolve(resp);
  });
};

export const comparePlansAction = (payload) => (dispatch) => {
  dispatch({ type: SET_PLAN_COMPARE_LOADER, payload: true });
  return subscriptionPlanService.comparePlans(payload).then((resp) => {
    console.log("comparePlansAction resp", resp);
    if (resp?.status) {
      dispatch({ type: SET_PLAN_COMPARE, payload: resp?.data });
    } else {
      dispatch({ type: SET_PLAN_COMPARE, payload: null });
      dispatch(setFailedMessage(resp?.data || resp?.message));
    }
    dispatch({ type: SET_PLAN_COMPARE_LOADER, payload: false });
    return Promise.resolve(resp);
  });
};
